/* SportScreen cart drawer extras — 2026-09-30 (note save + chat hide: 2026-10-01).
   Tabs (Cart / Recently viewed), recommendations row, "+ Add", order-note + discount toggles.
   Works alongside Dawn's cart-drawer.js / cart.js: the drawer's .drawer__inner is re-rendered
   by Dawn after every cart change, so everything here uses event delegation and re-hydrates
   through a MutationObserver. */
(function () {
  if (window.__ssCartDrawer) return;
  window.__ssCartDrawer = true;

  var RV_KEY = 'ss_recently_viewed';
  var recCache = {};
  var productCache = {};
  var pendingDiscountMsg = null;

  function drawer() { return document.querySelector('cart-drawer.ss-cd'); }
  function panel() { var d = drawer(); return d && d.querySelector('.drawer__inner'); }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function formatMoney(cents) {
    var p = panel();
    var fmt = (p && p.dataset.moneyFormat) || '${{amount}}';
    cents = typeof cents === 'string' ? parseInt(cents.replace('.', ''), 10) : Math.round(cents);
    function withDelims(n, precision, thousands, decimal) {
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      var parts = (n / 100).toFixed(precision).split('.');
      return parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands) + (parts[1] ? decimal + parts[1] : '');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return withDelims(cents, 0);
        case 'amount_with_comma_separator': return withDelims(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return withDelims(cents, 2, "'", '.');
        default: return withDelims(cents, 2);
      }
    });
  }

  function imgUrl(src, w) {
    if (!src) return '';
    if (typeof src === 'object') src = src.src || src.url || '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function firstAvailableVariant(p) {
    var v = (p.variants || []).filter(function (x) { return x.available; });
    return v.length ? v[0] : null;
  }

  function cardHTML(p) {
    var v = firstAvailableVariant(p);
    if (!v) return '';
    var price = v.price, compare = v.compare_at_price;
    var sale = compare && compare > price;
    var img = p.featured_image || (p.images && p.images[0]) || '';
    var url = p.url || ('/products/' + p.handle);
    return (
      '<div class="ss-cd-card">' +
        '<a class="ss-cd-card__media" href="' + esc(url) + '" tabindex="-1" aria-hidden="true">' +
          (img ? '<img src="' + esc(imgUrl(img, 160)) + '" alt="" loading="lazy" width="68" height="68">' : '') +
        '</a>' +
        '<div class="ss-cd-card__body">' +
          (p.vendor ? '<p class="ss-cd-card__vendor">' + esc(p.vendor) + '</p>' : '') +
          '<a class="ss-cd-card__title" href="' + esc(url) + '">' + esc(p.title) + '</a>' +
          '<div class="ss-cd-card__row">' +
            '<span class="ss-cd-card__price' + (sale ? ' ss-cd-card__price--sale' : '') + '">' + esc(formatMoney(price)) +
              (sale ? '<s>' + esc(formatMoney(compare)) + '</s>' : '') + '</span>' +
            '<button type="button" class="ss-cd-card__add" data-ss-cd-add="' + esc(v.id) + '" aria-label="Add ' + esc(p.title) + ' to cart">+ Add</button>' +
          '</div>' +
        '</div>' +
      '</div>'
    );
  }

  /* ---------- recommendations ---------- */
  function loadRecs() {
    var box = document.querySelector('cart-drawer.ss-cd [data-ss-cd-recs]');
    if (!box || box.dataset.ssFilled) return;
    box.dataset.ssFilled = '1';
    var p = panel();
    var pid = box.dataset.productId;
    if (!pid) return;
    var inCart = ((p && p.dataset.cartProductIds) || '').split(',');
    var base = (p && p.dataset.recsUrl) || '/recommendations/products';
    var render = function (products) {
      var html = (products || [])
        .filter(function (x) { return inCart.indexOf(String(x.id)) === -1; })
        .map(cardHTML).filter(Boolean).slice(0, 6).join('');
      var track = box.querySelector('[data-ss-cd-track]');
      if (!html || !track) { box.hidden = true; return; }
      track.innerHTML = html;
      box.hidden = false;
      updateArrows(track);
    };
    if (recCache[pid]) return render(recCache[pid]);
    fetch(base + '.json?product_id=' + encodeURIComponent(pid) + '&limit=10&intent=related')
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (j) { recCache[pid] = j.products || []; render(recCache[pid]); })
      .catch(function () { box.hidden = true; });
  }

  function updateArrows(track) {
    var box = track.closest('[data-ss-cd-recs]');
    if (!box) return;
    var prev = box.querySelector('[data-ss-cd-scroll="-1"]');
    var next = box.querySelector('[data-ss-cd-scroll="1"]');
    var max = track.scrollWidth - track.clientWidth - 2;
    if (prev) prev.disabled = track.scrollLeft <= 2;
    if (next) next.disabled = track.scrollLeft >= max;
    if (!track.dataset.ssScrollBound) {
      track.dataset.ssScrollBound = '1';
      track.addEventListener('scroll', function () { updateArrows(track); }, { passive: true });
    }
  }

  /* ---------- recently viewed ---------- */
  function getRecent() {
    try {
      var a = JSON.parse(window.localStorage.getItem(RV_KEY) || '[]');
      return Array.isArray(a) ? a.filter(function (h) { return typeof h === 'string' && /^[a-z0-9\-_]+$/i.test(h); }) : [];
    } catch (e) { return []; }
  }

  function loadRecent() {
    var list = document.querySelector('cart-drawer.ss-cd [data-ss-cd-recent]');
    if (!list || list.dataset.ssFilled) return;
    list.dataset.ssFilled = '1';
    var handles = getRecent().slice(0, 6);
    if (!handles.length) { list.innerHTML = '<p class="ss-cd__muted">Products you view will show up here.</p>'; return; }
    var p = panel();
    var root = ((p && p.dataset.rootUrl) || '/').replace(/\/$/, '');
    Promise.all(handles.map(function (h) {
      if (productCache[h]) return Promise.resolve(productCache[h]);
      return fetch(root + '/products/' + encodeURIComponent(h) + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) { if (j) productCache[h] = j; return j; })
        .catch(function () { return null; });
    })).then(function (products) {
      var html = products.filter(Boolean).map(cardHTML).filter(Boolean).join('');
      list.innerHTML = html || '<p class="ss-cd__muted">Products you view will show up here.</p>';
    });
  }

  /* ---------- tabs ---------- */
  function setTab(name) {
    var d = drawer();
    if (!d) return;
    d.querySelectorAll('[data-ss-cd-tab]').forEach(function (t) {
      var on = t.dataset.ssCdTab === name;
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    d.querySelectorAll('[data-ss-cd-panel]').forEach(function (pn) {
      pn.hidden = pn.dataset.ssCdPanel !== name;
    });
    if (name === 'recent') loadRecent();
  }

  /* ---------- cart mutations ---------- */
  function sectionsPayload() {
    return { sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname };
  }

  function rerender(state) {
    var d = drawer();
    if (!d || !state || !state.sections) return;
    d.classList.toggle('is-empty', state.item_count === 0);
    if (typeof d.renderContents === 'function') d.renderContents(state);
  }

  function addVariant(btn) {
    var id = parseInt(btn.dataset.ssCdAdd, 10);
    if (!id) return;
    btn.disabled = true;
    var label = btn.textContent;
    btn.textContent = 'Adding…';
    var body = Object.assign({ items: [{ id: id, quantity: 1 }] }, sectionsPayload());
    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status || res.errors) throw new Error(res.description || res.message || 'Error');
        var d = drawer();
        if (d) d.classList.remove('is-empty');
        rerender({ sections: res.sections, id: id, item_count: 1 });
      })
      .catch(function () {
        btn.disabled = false;
        btn.classList.add('is-error');
        btn.textContent = 'Unavailable';
        setTimeout(function () { btn.classList.remove('is-error'); btn.textContent = label; }, 2200);
      });
  }

  function updateCart(payload) {
    return fetch((window.routes && window.routes.cart_update_url ? window.routes.cart_update_url : '/cart/update') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(Object.assign(payload, sectionsPayload()))
    }).then(function (r) { return r.json(); });
  }

  /* Discount strategy:
     1) Ajax Cart API: POST /cart/update.js { discount: "A,B" } — Shopify validates the code
        against the cart and returns discount_codes[{code, applicable}]; the drawer re-renders
        with the real discounted subtotal and the code carries into checkout.
     2) Fallback (if the response has no discount_codes, i.e. API unsupported): GET /discount/CODE
        which stores the code in the session cookie so checkout applies it. */
  function currentCodes() {
    var d = drawer();
    if (!d) return [];
    return Array.prototype.map.call(d.querySelectorAll('[data-ss-cd-discount-remove]'), function (b) {
      return b.dataset.ssCdDiscountRemove;
    });
  }

  function discountMsg(text, cls) {
    var el = document.querySelector('cart-drawer.ss-cd [data-ss-cd-discount-msg]');
    if (!el) return;
    el.textContent = text;
    el.className = 'ss-cd__util-hint' + (cls ? ' ' + cls : '');
  }

  function applyDiscount() {
    var d = drawer();
    var input = d && d.querySelector('[data-ss-cd-discount-input]');
    var btn = d && d.querySelector('[data-ss-cd-discount-apply]');
    if (!input) return;
    var code = input.value.trim();
    if (!code) { discountMsg('Enter a discount code.', 'is-error'); input.focus(); return; }
    var existing = currentCodes();
    var codes = existing.filter(function (c) { return c.toLowerCase() !== code.toLowerCase(); }).concat([code]);
    if (btn) btn.disabled = true;
    discountMsg('Checking code…');
    updateCart({ discount: codes.join(',') })
      .then(function (cart) {
        if (!cart || !Array.isArray(cart.discount_codes)) {
          return fetch('/discount/' + encodeURIComponent(code)).then(function () {
            discountMsg('Code saved — it will be applied at checkout.', 'is-ok');
            if (btn) btn.disabled = false;
          });
        }
        var hit = cart.discount_codes.filter(function (c) { return String(c.code).toLowerCase() === code.toLowerCase(); })[0];
        if (hit && hit.applicable) {
          pendingDiscountMsg = { text: 'Code “' + code.toUpperCase() + '” applied.', cls: 'is-ok' };
          rerender(cart);
        } else {
          // Roll back so an unusable code doesn't linger on the cart.
          updateCart({ discount: existing.join(',') }).then(function (c2) {
            pendingDiscountMsg = { text: 'That code isn’t valid for this cart.', cls: 'is-error' };
            rerender(c2);
          });
        }
      })
      .catch(function () {
        if (btn) btn.disabled = false;
        discountMsg('Couldn’t apply the code. Please try again.', 'is-error');
      });
  }

  function removeDiscount(code) {
    var rest = currentCodes().filter(function (c) { return c !== code; });
    updateCart({ discount: rest.join(',') }).then(rerender).catch(function () {});
  }

  /* ---------- order note ----------
     Saves via POST /cart/update.js { note } (debounced). Status shows "Saved ✓" only after the
     response's cart.note matches what was sent; errors are shown. Textarea also carries
     form="CartDrawer-Form" so the latest note is posted with Check out. */
  var noteTimer = null, noteSeq = 0, lastSavedNote = null;
  function noteMsg(text, cls) {
    var el = document.querySelector('cart-drawer.ss-cd [data-ss-cd-note-msg]');
    if (!el) return;
    el.textContent = text;
    el.className = 'ss-cd__util-hint' + (cls ? ' ' + cls : '');
  }
  function noteDot(on) {
    var btn = document.querySelector('cart-drawer.ss-cd [data-ss-cd-toggle="SSCD-Note"] span');
    if (!btn) return;
    var dot = btn.querySelector('.ss-cd__util-dot');
    if (on && !dot) {
      dot = document.createElement('em');
      dot.className = 'ss-cd__util-dot';
      dot.setAttribute('aria-label', 'added');
      btn.appendChild(document.createTextNode(' '));
      btn.appendChild(dot);
    } else if (!on && dot) { dot.remove(); }
  }
  function saveNote(value) {
    clearTimeout(noteTimer); noteTimer = null;
    if (value === lastSavedNote) { noteMsg(value ? 'Saved ✓' : '', 'is-ok'); return Promise.resolve(); }
    var seq = ++noteSeq;
    noteMsg('Saving…', 'is-saving');
    return fetch((window.routes && window.routes.cart_update_url ? window.routes.cart_update_url : '/cart/update') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ note: value })
    })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function (cart) {
        if (!cart || cart.status || cart.errors) throw new Error('Rejected');
        if (seq !== noteSeq) return; // a newer save is in flight
        if ((cart.note || '') !== value) throw new Error('Mismatch');
        lastSavedNote = value;
        noteDot(!!value.trim());
        noteMsg(value ? 'Saved ✓' : 'Note removed ✓', 'is-ok');
        var other = document.getElementById('Cart-note');
        if (other && other.value !== value) other.value = value;
      })
      .catch(function () {
        if (seq !== noteSeq) return;
        noteMsg('Couldn’t save your note. Check your connection and try again.', 'is-error');
      });
  }
  function noteInput(t) {
    clearTimeout(noteTimer);
    noteMsg('Saving…', 'is-saving');
    noteTimer = setTimeout(function () { saveNote(t.value); }, 600);
  }

  /* Upgrades the drawer's note markup after every render: our handler replaces Dawn's <cart-note>
     listener (stopped in the capture phase), the textarea joins CartDrawer-Form, and the static
     "Saved automatically." hint becomes a live status line. */
  function prepNote() {
    var ta = document.querySelector('cart-drawer.ss-cd #CartDrawer-Note');
    if (!ta || ta.dataset.ssCdNoteInput != null) return;
    ta.setAttribute('data-ss-cd-note-input', '');
    ta.setAttribute('form', 'CartDrawer-Form');
    ta.setAttribute('maxlength', '5000');
    var wrap = ta.closest('cart-note') || ta.parentNode;
    var hint = wrap && wrap.nextElementSibling;
    if (hint && hint.classList.contains('ss-cd__util-hint')) {
      hint.setAttribute('data-ss-cd-note-msg', '');
      hint.setAttribute('role', 'status');
      hint.setAttribute('aria-live', 'polite');
      hint.textContent = ta.value.trim() ? 'Saved to your order.' : '';
      hint.className = 'ss-cd__util-hint' + (ta.value.trim() ? ' is-ok' : '');
    }
    if (lastSavedNote === null) lastSavedNote = ta.value;
  }

  /* ---------- body flag while the drawer is open (hides floating chat launchers via CSS) ---------- */
  function syncOpenFlag() {
    var d = drawer();
    document.documentElement.classList.toggle('ss-cd-open', !!(d && d.classList.contains('active')));
  }

  /* ---------- hydrate after every Dawn re-render ---------- */
  function hydrate() {
    loadRecs();
    prepNote();
    if (pendingDiscountMsg) {
      var t = document.querySelector('cart-drawer.ss-cd [data-ss-cd-toggle="SSCD-Discount"]');
      var pnl = document.getElementById('SSCD-Discount');
      if (t && pnl) { t.setAttribute('aria-expanded', 'true'); pnl.hidden = false; }
      discountMsg(pendingDiscountMsg.text, pendingDiscountMsg.cls);
      pendingDiscountMsg = null;
    }
  }

  var hydrateTimer;
  function scheduleHydrate() { clearTimeout(hydrateTimer); hydrateTimer = setTimeout(hydrate, 30); }

  function boot() {
    var d = drawer();
    if (!d) return;
    var root = d.querySelector('#CartDrawer') || d;
    new MutationObserver(scheduleHydrate).observe(root, { childList: true, subtree: true });
    new MutationObserver(syncOpenFlag).observe(d, { attributes: true, attributeFilter: ['class'] });
    syncOpenFlag();
    hydrate();

    // Capture phase: runs before (and stops) Dawn's <cart-note> input listener, so the note is
    // saved exactly once, by us, with a real status.
    d.addEventListener('input', function (e) {
      if (e.target && e.target.id === 'CartDrawer-Note') { e.stopPropagation(); prepNote(); noteInput(e.target); }
    }, true);
    d.addEventListener('focusout', function (e) {
      if (e.target && e.target.id === 'CartDrawer-Note' && noteTimer) saveNote(e.target.value);
    }, true);

    d.addEventListener('click', function (e) {
      var tab = e.target.closest('[data-ss-cd-tab]');
      if (tab) { e.preventDefault(); setTab(tab.dataset.ssCdTab); return; }

      var tog = e.target.closest('[data-ss-cd-toggle]');
      if (tog) {
        e.preventDefault();
        var target = document.getElementById(tog.dataset.ssCdToggle);
        if (!target) return;
        var open = tog.getAttribute('aria-expanded') !== 'true';
        d.querySelectorAll('[data-ss-cd-toggle]').forEach(function (o) {
          if (o === tog) return;
          o.setAttribute('aria-expanded', 'false');
          var ot = document.getElementById(o.dataset.ssCdToggle);
          if (ot) ot.hidden = true;
        });
        tog.setAttribute('aria-expanded', open ? 'true' : 'false');
        target.hidden = !open;
        if (open) {
          var f = target.querySelector('textarea, input');
          if (f) f.focus();
          var sc = target.closest('.ss-cd__scroll');
          if (sc) setTimeout(function () { sc.scrollTop = sc.scrollHeight; }, 20);
        }
        return;
      }

      var add = e.target.closest('[data-ss-cd-add]');
      if (add) { e.preventDefault(); addVariant(add); return; }

      var arrow = e.target.closest('[data-ss-cd-scroll]');
      if (arrow) {
        e.preventDefault();
        var track = arrow.closest('[data-ss-cd-recs]').querySelector('[data-ss-cd-track]');
        var card = track && track.querySelector('.ss-cd-card');
        if (!track || !card) return;
        var step = card.getBoundingClientRect().width + 10;
        track.scrollBy({ left: step * parseInt(arrow.dataset.ssCdScroll, 10), behavior: 'smooth' });
        return;
      }

      if (e.target.closest('[data-ss-cd-discount-apply]')) { e.preventDefault(); applyDiscount(); return; }

      var rm = e.target.closest('[data-ss-cd-discount-remove]');
      if (rm) { e.preventDefault(); removeDiscount(rm.dataset.ssCdDiscountRemove); }
    });

    d.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.matches && e.target.matches('[data-ss-cd-discount-input]')) {
        e.preventDefault();
        applyDiscount();
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
